module.exports = __webpack_public_path__ + "static/img/170810-nasopharyngeal-carcinoma.63b11da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/170810-nasopharyngeal-carcinoma.jpg
// module id = 0iFu
// module chunks = 0